import { render, staticRenderFns } from "./AmbassadorLink.vue?vue&type=template&id=33d810e0&"
import script from "./AmbassadorLink.vue?vue&type=script&lang=js&"
export * from "./AmbassadorLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports